<template>
  <div class="set-sexy">
    <p class="who">你是</p>
    <div class="choose-con">
      <span class="sexy"
        v-for="item in sexArr"
        :key="item.value"
        :class="[item.value == '1' ? 'male' : 'female', {'selected': sex == item.value }]"
        @touchstart="selectItem(item.value, 1)"
        @touchend="skipStep(1)"
      ></span>
    </div>
    <p class="cautious">选择后不可更改哦，请谨慎选择</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setCookie, getCookie } from '@/utils/tools'
export default {
  data () {
    return {
      sex: null
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      sexMap: 'sexMap'
    }),
    sexArr () {
      let arr = []
      for (let i in this.sexMap) {
        arr.push({
          value: i,
          text: this.sexMap[i]
        })
      }
      return arr
    }
  },
  methods: {
    selectItem (val) {
      if (!val) return
      this.sex = val
      setCookie('sex', val)
    },
    skipStep () {
      this.$router.push({
        name: 'SetEducation'
      })
    }
  },
  mounted () {
    let sex = getCookie('sex')
    if (sex) {
      this.sex = sex
    }
  }
}
</script>
